



































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Helpers } from '@/tools/helpers';
import { BusinessCategory, Pagination, PublicSupplierSearchList } from '@/store/models';
import { fetchNeraMatchingSuppliers, fetchProjectCategoriesByToken } from '@/store/api';

@Component({
  components: {},
})
export default class SupplierPublicSearch extends Vue {
  private searchValid: boolean = true;
  private mapOptions = { minZoom: 1, maxZoom: 15, scaleControl: true, zoom: 4 };
  private loaded: boolean = true;
  private fetched: boolean = false;
  private tipObj: any | null = null;
  private projectCategories: BusinessCategory[] = [];

  private markerIcon: any = {
    path: Helpers.PinPathCubicBezier(16, 26),
    fillColor: '#EA4335',
    fillOpacity: 1,
    scale: 1,
    strokeColor: '#fff',
    strokeWeight: 1,
  };
  private ranges = [
    {
      text: 'Within 5Kms',
      value: 5,
    },
    {
      text: 'Within 25Kms',
      value: 25,
    },
    {
      text: 'Within 50Kms',
      value: 50,
    },
    {
      text: 'Within 100Kms',
      value: 100,
    },
    {
      text: 'Within 150Kms',
      value: 150,
    },
    {
      text: 'Within 200Kms',
      value: 200,
    },
  ];

  private filters: any = {
    keyword: null,
    location: null,
    range: null,
    page: 1,
    limit: 10,
    category_ids: [],
    by_public_profile: true,
  };
  private place: any = null;
  private mapMarkers: any = [];
  private results: any = [];
  private pagination: Pagination = {
    current: 1,
    next: 2,
    previous: 0,
    limit: 10,
    total_pages: null,
    total_count: null,
  };

  get hasFilters() {
    return this.filters.keyword || this.filters.location || this.filters.category_ids.length > 0;
  }

  get locationPresent() {
    return !!this.place;
  }

  private setPlace(place: any) {
    this.filters.location = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
      address: place.formatted_address,
      name: place.name,
      viewport: {
        northeast: {
          lat: place.geometry.viewport.getNorthEast().lat(),
          lng: place.geometry.viewport.getNorthEast().lng(),
        },
        southwest: {
          lat: place.geometry.viewport.getSouthWest().lat(),
          lng: place.geometry.viewport.getSouthWest().lng(),
        },
      },
    };
    this.place = place.formatted_address;
  }

  private placeChanged(value: any) {
    this.place = value;
    if (!this.place) {
      this.filters.location = null;
      this.filters.range = null;
    }
  }

  private mounted() {
    this.neraCategories();
    this.search_public_supplier();
  }

  private clearSearch() {
    this.place = null;
    this.filters = {
      keyword: null,
      location: null,
      range: null,
      page: 1,
      limit: 10,
      category_ids: [],
    };
    this.search_public_supplier();
  }

  private neraCategories() {
    if (this.$route.query.token) {
      console.log('fetchProjectCategoriesByToken');
      fetchProjectCategoriesByToken(this.$route.query.token).then((res: any) => {
        this.projectCategories = res.categories;
        console.log('res', res);
      });
    }
  }

  private search_public_supplier() {
    this.results = [];
    this.loaded = false;
    this.fetched = true;
    if (this.searchValid) {
      if (this.$route.query.token) {
        const token = this.$route.query.token;
        fetchNeraMatchingSuppliers(token, this.filters).then((res: any) => {
          this.setMapMarkers(res);
        });
      }
      this.loaded = true;
    }
  }

  private setMapMarkers(matchedSuppliers: PublicSupplierSearchList) {
    this.mapMarkers = [];
    if (matchedSuppliers) {
      this.results = JSON.parse(JSON.stringify(matchedSuppliers.data));
      this.pagination = JSON.parse(JSON.stringify(matchedSuppliers.pagination));
      this.results.forEach((s: any) => {
        s.path = '/business/' + s.public_profile_path;
        s.head_office = s.locations.find((e: any) => {
          return e.location_type === 'Head';
        });
        s.branch_office = s.locations.find((e: any) => {
          return e.location_type === 'Branch';
        });
        if (this.filters.locations) {
          s.locations.forEach((l: any) => {
            this.pushToMarker(l, s);
          });
        } else {
          if (s.head_office || s.branch_office) {
            s.address = s.head_office ? s.head_office.address : s.branch_office.address;
            this.pushToMarker(s.head_office ? s.head_office : s.branch_office, s);
          }
        }
      });
      const bounds = new (window as any).google.maps.LatLngBounds();
      this.mapMarkers.forEach((m: any) => {
        bounds.extend(m.position);
      });
      this.$nextTick(() => {
        (this.$refs.mapRef as any).$mapPromise.then((map: any) => {
          map.fitBounds(bounds, 10);
        });
      });
    }
  }

  private pushToMarker(location: any, supplier: any) {
    const marker = new (window as any).google.maps.Marker({
      supplier,
      address: location.address,
      position: {
        lat: location.latitude,
        lng: location.longitude,
      },
      icon: this.markerIcon,
      tooltip: supplier.trading_name,
    });
    this.mapMarkers.push(marker);
  }

  private mouseOver(event: any, marker: any) {
    const position = { x: event.domEvent.pageX + window.scrollX, y: event.domEvent.pageY };
    if (!this.tipObj) {
      // create the tooltip object
      this.tipObj = document.createElement('div');
      this.tipObj.setAttribute('id', `marker_tip_${marker.supplier.id}`);
    }
    this.tipObj.style.display = 'block';
    this.tipObj.style.border = '1px solid #3E946A';
    this.tipObj.style.background = '#fcfcfc';
    this.tipObj.style.padding = '4px';
    this.tipObj.style.height = 'auto';
    this.tipObj.style.width = 'auto';
    this.tipObj.style['box-shadow'] = '1px 3px rgba(120, 120, 120, 0.2)';
    this.tipObj.style['z-index'] = '100';
    this.tipObj.style['pointer-events'] = 'none';
    this.tipObj.innerHTML = marker.tooltip;
    // position it
    this.tipObj.style.position = 'absolute';
    this.tipObj.style.top = position.y + 'px';
    this.tipObj.style.left = position.x + 'px';
    // add it to the body
    document.body.appendChild(this.tipObj);
  }

  private mouseOut(event: any, marker: any) {
    if (this.tipObj) {
      this.tipObj.style.display = 'none';
    }
  }

  private linkify(text: string) {
    return Helpers.linkify(text);
  }

  private data() {
    return {};
  }
}
